import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import "./work.css";
import Carousel, { Modal, ModalGateway } from "react-images";
import dd1 from "../../assests/image/dd1.jpg";
import d1 from "../../assests/image/d1.png";
import d88 from "../../assests/image/d88.png";
const photos = [
  {
    src: dd1,
    width: 4,
    height: 3,
  },
  {
    src: d1,
    width: 4,
    height: 3,
  },
  {
    src: d88,
    width: 4,
    height: 3,
  },
];

const Lightboxcode4 = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };
  return (
    <div>
      <div className="light1box mb-1">
        <Gallery photos={photos} onClick={openLightbox} />
      </div>

      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={photos.map((x) => ({
                ...x,
                srcset: x.srcSet,
                caption: x.title,
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
};
export default Lightboxcode4;
